import React from 'react'
import { Column } from '@components/Common'
import { Tab, Tabs } from '@components/Tabs/index'
import { generateRandomKey } from '@utils'

const TabsRow = ({ tab, setTab = () => {}, practiceArray }) => {
  const tabsArr = [
    'overview',
    practiceArray?.[1]?.nodes?.length > 0 || practiceArray?.[1]?.length > 0
      ? 'insights'
      : null,
    practiceArray?.[2]?.length > 0 ? 'professionals' : null,
    practiceArray?.[3]?.length > 0 ? 'news & events' : null,
  ]

  return (
    <Column className="bg-white">
      <Tabs
        color="white"
        aria-label="Tabbed Content Navigation"
        setTab={setTab}
        tab={tab}
        background="white"
        maxWidth
      >
        {tabsArr &&
          tabsArr.map(
            (t, index) =>
              t !== null &&
              t !== undefined && (
                <Tab
                  upperCase
                  label={tabsArr[index]}
                  border="1px solid #5f606254"
                  fontSize="13px"
                  key={generateRandomKey()}
                  index={index}
                  padding="11px 14px"
                  tab={tab}
                  setTab={setTab}
                />
              )
          )}
      </Tabs>
    </Column>
  )
}

export default TabsRow
